
import { computed, ComputedRef, defineComponent } from "vue";
import { useStore } from "vuex";

export default defineComponent({
  name: "NotificationButton",
  setup() {
    const store = useStore();

    const hasNewNotifications: ComputedRef<boolean> = computed(
      () => store.getters["notification_module/hasNewNotifications"]
    );

    return {
      hasNewNotifications
    };
  }
});
